import {AppFrameDeskFeat, IApp, IAppBuilder, IAppCtx, JAppDef} from "back/core/appFrame";
import {SimpleTagArea} from "lib/commons/areas";
import {IReg, IUiEnv, REG} from 'lib/commons/registry';
import {JSX} from "lib/commons/xml/dom";
import {OShowAppInit, ShowApp} from "back/core/apps/frameApp";
import {IResolverPointer} from "lib/commons/io/io";

/**
 * Résultat d'un service, ou page web affichée comme une vue principale dans une appFrame (contexte authentifié)
 * A appeler au cours du processus d'init du desk (qui doit disposer de AppFrameDeskFeat).
 *
 * @param reg Registre à exploiter, nécessaire en cas de front multi-universe.
 *
 * Registre :
 * 	liste 'plg:show:domains:white'
 */
export function initApp(reg: IReg<IResolverPointer & IUiEnv> = REG.reg) {
	const d = desk as AppFrameDeskFeat;
	d.addAppBuilder(new ShowAppBuilder(reg));
}

/**
 * Schéma du hash de l'URL pour le ShowApp.
 * exemple : (show(url'http://xxxx/mySvc'))
 */
export interface JShowAppDef extends JAppDef {
	show: {
		/** URL libre (soumise au contrôle {@link IO.isRedirectValid}) */
		url?: string,
		/** Ref à une URL du registre */
		alias: string,
	}
}

/** Construction async de l'app ShowApp. */
class ShowAppBuilder extends SimpleTagArea<IAppCtx<IUiEnv>, IApp<IUiEnv>> implements IAppBuilder<IUiEnv, IUiEnv> {

	skinOver?: string;

	constructor(public reg: IReg<IResolverPointer & IUiEnv>) {
		super('show-app', reg.env.resolver.resolve(":back:core/apps/frameApp.js"));
	}

	isAppDefMatch(data: JShowAppDef) {
		return (typeof data.show === 'object') && (data.show.url != '' || data.show.alias != '')
	}

	newElt(ctx: OShowAppInit): ShowApp {
		if (!ctx.skinOver) ctx.skinOver = this.skinOver;
		if (!ctx.whiteDomains) ctx.whiteDomains = ctx.reg.getList("plg:show:domains:white") as (string)[];
		if (!ctx.aliasUrls) ctx.aliasUrls = ctx.reg.getListAsMap("plg:show:alias:url");
		ctx.reg = this.reg;
		return (super.newElt(ctx) as ShowApp).initialize(ctx);
	}
}
